var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_13132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9542 10.362C18.8419 9.98298 18.5168 9.7057 18.1248 9.65458L14.4041 9.14061L12.9317 5.6224C12.7168 5.10743 12.125 4.86426 11.61 5.07922C11.3646 5.18172 11.1694 5.37688 11.0669 5.62237L9.59452 9.14058L5.87382 9.65456C5.31945 9.73175 4.93262 10.2437 5.00981 10.798C5.04297 11.0363 5.15977 11.2549 5.33934 11.4149L8.14262 13.9147L7.56666 17.8374C7.50427 18.2357 7.68721 18.6326 8.03063 18.8438C8.36922 19.0604 8.80474 19.0523 9.13503 18.8233L11.9993 16.8755L14.8636 18.8253C15.3258 19.139 15.9547 19.0186 16.2685 18.5565C16.411 18.3464 16.4694 18.0905 16.432 17.8394L15.856 13.9152L18.6593 11.4154C18.957 11.1533 19.0725 10.7406 18.9542 10.362Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_13132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6e567bc89767c70123b6c3e488f89dcb.svg";
export { ForwardRef as ReactComponent };